import React from 'react'
import Image from 'react-bootstrap/Image'
import { Button } from 'react-bootstrap'

export default function HelpValheim() {
    return (
        <div>
            <div className='c_c'>
                <Image className='Tr_block_img' src='https://coop-land.ru/uploads/posts/2021-06/1624971626_bez-imeni-1.jpg'>
                </Image>
            </div>

            <div className='All_block_one'>
                <p className='All_text_block_one'>
                    Играй с нами в Valheim и не забудь вступить в наш Discord сообщество <br />
                    IP сервера: <u>86.110.212.173:2456</u>
                </p>
            </div>

            <div className='HelpValheim_button_block'>
                <Button className='HelpValheim_button' variant="dark" target='_blank' href='https://vk.com/topic-205471999_47763771'>Инструкия / Скачать</Button>
            </div>
            <div className='Tr_stick'></div>
        </div>
    )
}
